export function CreateUserSessionProperties(payload){
  return {
    type: "CreateUserSession",
    payload: payload,
  };
}
export function RemoveUserSessionProperties(){
  return {
    type: "RemoveUserSession",
    payload: {},
  };
}
export function UpdateUserSessionProperties(payload){
  return {
    type: "UpdateUserSession",
    payload: payload,
  };
}
export function UpdateTenantLogoLoginSessionProperties(payload){
  return {
    type: "UpdateTenantLogoLoginSession",
    payload: payload,
  };
}
export function ToogleAuthSessionProperties(in_auth){
  return {
    type: "AuthToogle",
    payload: in_auth
  };
}
export function StoreUserInformation(payload){
  return {
    type: "StoreUserInformation",
    payload: payload,
  };
}
export function StoreUserInfoFromMobile(payload){
  return {
    type: "StoreUserInfoFromMobile",
    payload
  };
}
export function UpdateUserInformation(payload){
  return {
    type: "UpdateUserInformation",
    payload
  };
}



// WEBPACK FOOTER //
// ./src/App/user/action.js